var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame113(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 78,
    viewBox: "0 0 118 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8649 67.5297C87.8682 67.3389 87.8699 67.1476 87.8699 66.9559C87.8699 48.9172 73.2466 34.2939 55.2079 34.2939C37.1692 34.2939 22.5459 48.9172 22.5459 66.9559C22.5459 67.1476 22.5475 67.3389 22.5508 67.5297H87.8649Z",
    fill: "#E0B598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34473 33.1486L23.1194 44.609M1.34473 57.7884L19.6813 59.5074M93.6005 55.4963L117.094 48.6201M86.1513 43.4629L106.207 29.1375M71.8259 33.1486L80.9941 17.6771M54.0623 29.1375V6.2168M36.8718 37.1597L24.8384 17.6771M23.1194 69.8217C28.0855 60.6534 34.5797 41.7439 56.9274 41.7439C70.1068 41.7439 85.5783 53.7772 89.0164 69.8217H23.1194Z",
    stroke: "black",
    strokeWidth: 1.14603,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame113);
export default __webpack_public_path__ + "static/media/Frame113.db4ecd02ee2c2a6c1b48e4ef95b36c46.svg";
export { ForwardRef as ReactComponent };